<template>
  <report
    :title="$t('language.monthlyattendancesummary')"
    :filter="filter"
    :url="url"
    @filtered="filtered"
  >
    <template v-slot:filter>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.year')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.year"
            :items="YearList"
            item-text="name"
            item-value="id"
            :label="$t('language.year')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm12 md3>
        <ValidationProvider
          :name="$t('language.month')"
          rules="required"
          v-slot="{ errors }"
        >
          <v-autocomplete
            dense
            v-model="filter.month"
            :items="MonthList"
            item-text="name"
            item-value="id"
            :label="$t('language.month')"
            :error-messages="errors[0]"
            :clearable="true"
          ></v-autocomplete>
        </ValidationProvider>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.personid"
          :items="PersonList"
          item-text="name"
          item-value="id"
          :label="$t('language.person')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.branchid"
          :items="BranchList"
          item-text="name"
          item-value="id"
          :label="$t('language.branch')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.departmentid"
          :items="DepartmentList"
          item-text="name"
          item-value="id"
          :label="$t('language.department')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.designationid"
          :items="DesignationList"
          item-text="name"
          item-value="id"
          :label="$t('language.designation')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
      <v-flex xs12 sm6 md3>
        <v-autocomplete
          dense
          v-model="filter.modeid"
          :items="ModeList"
          item-text="name"
          item-value="id"
          :label="$t('language.mode')"
          :clearable="true"
        ></v-autocomplete>
      </v-flex>
    </template>
    <template v-slot:printheader>
      <table class="printheader">
        <tbody>
          <tr>
            <td>{{ $t("language.year") }}:{{ selectedyear }}</td>
            <td></td>
            <td>{{ $t("language.month") }}:{{ selectedmonth }}</td>
            <td></td>
            <td>{{ $t("language.person") }}:{{ selectedperson }}</td>
            <td></td>
            <td>{{ $t("language.branch") }}:{{ selectedbranch }}</td>
            <td></td>
            <td>{{ $t("language.department") }}:{{ selecteddepartment }}</td>
            <td></td>
            <td>{{ $t("language.designation") }}:{{ selecteddesignation }}</td>
            <td></td>
            <td>{{ $t("language.mode") }}:{{ selectedmode }}</td>
          </tr>
        </tbody>
      </table>
    </template>
    <template v-slot:table>
      <table class="table table-bordered w-100 print-align-center align-center">
        <thead>
          <tr>
            <th width="150" rowspan="2">{{ $t("language.person") }}</th>
            <th rowspan="2">{{ $t("language.designationshort") }}</th>
            <th colspan="2">{{ $t("language.weekend") }}</th>
            <th colspan="2">{{ $t("language.holiday") }}</th>
            <th colspan="2">{{ $t("language.leave") }}</th>
            <th colspan="2">{{ $t("language.officialvisit") }}</th>
            <th rowspan="2">{{ $t("language.present") }}</th>
            <th rowspan="2">{{ $t("language.absent") }}</th>
            <th rowspan="2">{{ $t("language.latein") }}</th>
            <th rowspan="2">{{ $t("language.earlyout") }}</th>
            <th rowspan="2">{{ $t("language.workedhour") }}</th>
          </tr>
          <tr>
            <th>{{ $t("language.day") }}</th>
            <th>{{ $t("language.present") }}</th>

            <th>{{ $t("language.day") }}</th>
            <th>{{ $t("language.present") }}</th>

            <th>{{ $t("language.day") }}</th>
            <th>{{ $t("language.present") }}</th>

            <th>{{ $t("language.day") }}</th>
            <th>{{ $t("language.present") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td>{{ item.person }}</td>
            <td>{{ item.designation }}</td>

            <td>{{ item.weekend }}</td>
            <td>{{ item.presentweekend + item.presentholidayweekend }}</td>

            <td>{{ item.holiday + item.holidayweekend }}</td>
            <td>{{ item.presentholiday }}</td>

            <td>{{ item.leave }}</td>
            <td>{{ item.presentleave }}</td>

            <td>{{ item.officialvisit }}</td>
            <td>{{ item.presentofficialvisit }}</td>

            <td>{{ item.present }}</td>
            <td>{{ item.absent }}</td>
            <td>{{ item.latein }}</td>
            <td>{{ item.earlyout }}</td>
            <td>{{ item.workedhour }}</td>
          </tr>
        </tbody>
      </table>
    </template>
  </report>
</template>
<script>
import axios from "axios";
import moment from "moment";
import Report from "../Report";
import commonservice from "../../../../shared/common.service";
export default {
  components: {
    Report,
  },
  data() {
    return {
      filter: {
        year: commonservice.getCurrentYear(),
        month: commonservice.getCurrentMonth(),
        personid: null,
        branchid: null,
        departmentid: null,
        designationid: null,
        modeid: null,
      },
      YearList: [],
      MonthList: commonservice.getMonthList(),
      PersonList: [],
      BranchList: [],
      DepartmentList: [],
      DesignationList: [],
      ModeList: [],
      url: "client/report/monthly/attendancesummaries",
      data: [],
    };
  },
  computed: {
    selectedyear() {
      if (this.filter.year == null) return this.$t("language.all");
      return this.YearList.filter((c) => {
        return c.id == this.filter.year;
      })[0].name;
    },
    selectedmonth() {
      if (this.filter.month == null) return this.$t("language.all");
      return this.MonthList.filter((c) => {
        return c.id == this.filter.month;
      })[0].name;
    },
    selectedperson() {
      if (this.filter.personid == null) return this.$t("language.all");
      return this.PersonList.filter((c) => {
        return c.id == this.filter.personid;
      })[0].name;
    },
    selectedbranch() {
      if (this.filter.branchid == null) return this.$t("language.all");
      return this.BranchList.filter((c) => {
        return c.id == this.filter.branchid;
      })[0].name;
    },
    selecteddepartment() {
      if (this.filter.departmentid == null) return this.$t("language.all");
      return this.DepartmentList.filter((c) => {
        return c.id == this.filter.departmentid;
      })[0].name;
    },
    selecteddesignation() {
      if (this.filter.designationid == null) return this.$t("language.all");
      return this.DesignationList.filter((c) => {
        return c.id == this.filter.designationid;
      })[0].name;
    },
    selectedmode() {
      if (this.filter.modeid == null) return this.$t("language.all");
      return this.ModeList.filter((c) => {
        return c.id == this.filter.modeid;
      })[0].name;
    },
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/report/monthly/init/list").then((response) => {
      next((p) => {
        p.DepartmentList = response.data.departments;
        p.BranchList = response.data.branches;
        p.DesignationList = response.data.designations;
        p.ModeList = response.data.modes;
        p.YearList = response.data.years;
        p.PersonList = response.data.persons;
      });
    });
  },
  methods: {
    filtered(filtereddata) {
      this.data = [];
      this.PersonList.forEach((c) => {
        let hasData =
          filtereddata.filter((d) => {
            return d.personid == c.id;
          }).length > 0;
        if (hasData) {
          const model = filtereddata.find(f=>f.personid == c.id);
          this.data.push({
            person: model.person,
            designation: model.designation, //c.designation,
            present: this.getdays("PRESENT", c.id, filtereddata),
            absent: this.getdays("ABSENT", c.id, filtereddata),
            leave: this.getdays("LEAVE", c.id, filtereddata),
            officialvisit: this.getdays("OFFICIALVISIT", c.id, filtereddata),
            holiday: this.getdays("HOLIDAY", c.id, filtereddata),
            weekend: this.getdays("WEEKEND", c.id, filtereddata),
            presentholiday: this.getdays("PRESENTHOLIDAY", c.id, filtereddata),
            presentweekend: this.getdays("PRESENTWEEKEND", c.id, filtereddata),
            presentleave: this.getdays("PRESENTLEAVE", c.id, filtereddata),
            presentofficialvisit: this.getdays(
              "PRESENTOFFICIALVISIT",
              c.id,
              filtereddata
            ),
            presentholidayweekend: this.getdays(
              "PRESENTHOLIDAYWEEKEND",
              c.id,
              filtereddata
            ),
            holidayweekend: this.getdays("HOLIDAYWEEKEND", c.id, filtereddata),
            latein: this.getdays("LATEIN", c.id, filtereddata),
            earlyout: this.getdays("EARLYOUT", c.id, filtereddata),
            workedhour: this.getdays(
              "WORKEDHOUR",
              c.id,
              filtereddata,
              true,
              "00:00"
            ),
          });
        }
      });
    },
    getdays(status, personid, list, istext, defaultext) {
      let summaries = list.filter((c) => {
        return c.status.indexOf(status) > -1 && c.personid == personid;
      });
      if (summaries.length > 0){
        if(istext)
          return summaries[0].totaldays;
        else{
          return summaries.reduce((a, b) => a + (parseFloat(b["totaldays"]) || 0), 0); // parseFloat(summaries[0].totaldays);
        }
      }
      return istext ? defaultext : 0;
    },
  },
};
</script>
